export const MulticallContractAddress = '0x18E317A7D70d8fBf8e6E893616b52390EbBdb629'
export const TreasuryAddress = '0x4b6aB5F819A515382B0dEB6935D793817bB4af28'
export const AwakenedWhitelistAddress = '0xCace1b78160AE76398F486c8a18044da0d66d86D'
export const AwakenedMintPassAddress = '0xF8e31cb472bc70500f08Cd84917E5A1912Ec8397'
export const AwakenedChampionAddress = '0x22753E4264FDDc6181dc7cce468904A80a363E44'
